// FormFrame/Field.tsx
import * as React from "react"
import type { FieldDef, FormApi } from "./fields/fieldTypes"

import { FieldHidden } from "./fields/FieldHidden"
import { FieldDivider } from "./fields/FieldDivider"
import { FieldCheckbox } from "./fields/FieldCheckbox"
import { FieldText } from "./fields/FieldText"
import { FieldDate } from "./fields/FieldDate"
import { FieldTextarea } from "./fields/FieldTextarea"
import { FieldSelect } from "./fields/FieldSelect"
import { FieldMultiSelect } from "./fields/FieldMultiSelect"
import { FieldRadio } from "./fields/FieldRadio"

import { getErrorText } from "./fields/fieldUtils"

export type { FieldDef, FieldOption } from "./fields/fieldTypes"

type Props = {
    def: FieldDef
    form: FormApi
}

export function Field({ def, form }: Props) {
    if (def.type === "hidden") return <FieldHidden def={def} form={form} />
    if (def.type === "divider") return <FieldDivider def={def} />

    const err = (form.formState.errors as any)?.[def.name]
    const errorText = getErrorText(err)
    const invalid = !!errorText

    if (def.type === "checkbox")
        return <FieldCheckbox def={def} form={form} invalid={invalid} />

    if (def.type === "date")
        return <FieldDate def={def} form={form} invalid={invalid} />

    if (def.type === "textarea")
        return <FieldTextarea def={def} form={form} invalid={invalid} fill={(def as any).fill} />

    if (def.type === "select")
        return <FieldSelect def={def} form={form} invalid={invalid} />

    if (def.type === "multiselect")
        return <FieldMultiSelect def={def} form={form} invalid={invalid} />

    if (def.type === "radio")
        return <FieldRadio def={def} form={form} invalid={invalid} />

    return <FieldText def={def} form={form} invalid={invalid} />
}
